import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { Sort, MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { FilterParameter, QueryParamsService } from 'common';
import { AuditTrailComponentData, AuditTrailData, AuditFilters, AuditQueryParams } from '../audit-trail.model';
import { AuditTrailFilterService } from '../audit-trail-filter.services';
import { AuditTrailListFilterDialogComponent } from '../audit-trail-list-filter-dialog/audit-trail-list-filter-dialog.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-audit-trail',
    templateUrl: './audit-trail.component.html',
    styleUrls: ['./audit-trail.component.scss'],
    standalone: false
})
export class AuditTrailComponent implements OnInit {

  @Input()
  detailTabbed: boolean;

  @Input()
  innerTabbed: boolean;

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  @ViewChild(MatSort)
  sort: MatSort;

  queryParams: AuditQueryParams;
  data: AuditTrailComponentData;
  filters: AuditFilters;
  activeFilters: FilterParameter[] = [];

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public _auditTrailFilterService: AuditTrailFilterService,
    public queryParamsService: QueryParamsService) {
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: AuditTrailComponentData) => {
        this.data = it;
      });

    this.route.queryParams.pipe(untilDestroyed(this))
      .subscribe(params => {
        this.queryParams = new AuditQueryParams(this.queryParamsService.init(params));
        this.activeFilters = this._auditTrailFilterService.addFilterParameters(this.queryParams);
      });

    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex = this.queryParams.skip / this.queryParams.limit;
  }

  filterDialog() {
    AuditTrailListFilterDialogComponent.show(this.dialog, this.queryParams)
      .subscribe(result => {
        if (result) {
          this.filters = result;
          this.paginator.firstPage();
          this._auditTrailFilterService.filter(result, this.paginator, this.sort);
        }
      });
  }

  activeFilterRemoved(activefilters: FilterParameter[]): void {
    if (!activefilters.length) return;
    activefilters.forEach(item => {
      this.filters.remove(item.id);
      this._auditTrailFilterService.filter(this.filters, this.paginator, this.sort);
    });
  }

  sortData(sort: Sort) {
    this._auditTrailFilterService.filter(this.filters, this.paginator, this.sort);
  }

  setPage(event: PageEvent) {
    this._auditTrailFilterService.filter(this.filters, this.paginator, this.sort);
  }

  tableColumns: string[] = [
    'date',
    'event',
    'initiator',
    'edit'
  ];

  getFormattedEvent(e: string): string {
    return _.startCase(e);
  }

  auditDetailsLink(audit: AuditTrailData) {
    return `/audit/${audit.id}}`;
  }
}
